import React from 'react';
import './Textarea.css';

export function Textarea({ label, error, hint, className = '', id, ...props }) {
  const textareaId = id || (label ? `textarea-${label.replace(/\s/g, '-').toLowerCase()}` : undefined);

  return (
    <div className={`ui-textarea-wrap ${error ? 'ui-textarea-wrap--error' : ''} ${className}`}>
      {label && <label className="ui-textarea__label" htmlFor={textareaId}>{label}</label>}
      <textarea className="ui-textarea" id={textareaId} {...props} />
      {(error || hint) && (
        <span className={`ui-textarea__hint ${error ? 'ui-textarea__hint--error' : ''}`}>
          {error || hint}
        </span>
      )}
    </div>
  );
}
